import { CommonModule } from '@angular/common';
import { Component, OnInit, input, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { fieldSorter } from '@scandium-oy/ngx-scandium';
import { map, shareReplay } from 'rxjs/operators';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { InstructionCategory } from 'src/app/models/instruction-category.model';
import { InstructionsService } from 'src/app/services/instructions.service';
import { SelectCategoryDialogComponent } from './select-category/select-category.dialog';

@Component({
  selector: 'app-new-category-dialog',
  templateUrl: './new-category.dialog.html',
  styleUrls: ['./new-category.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule, AppCommonModule,
    MainDialogComponent,
  ],
})
export class NewCategoryDialogComponent implements OnInit {

  categories$ = this.instructions.getCategories().pipe(
    map((items) => items?.sort(fieldSorter(['name'])) ?? []),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  formGroup: FormGroup;

  item = input<InstructionCategory>(null);

  constructor(
    private instructions: InstructionsService,
    private _modal: ModalController,
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    const item = this.item();
    this.formGroup = this.formBuilder.group({
      guid: [item?.guid ?? null],
      name: [item?.name ?? '', Validators.required],
      parent: [item?.parent ?? null],
    });
  }

  selectCategory(items: InstructionCategory[]) {
    const clearButton = this.formGroup.get('parent').value != null;
    this.modalCtrl.create({ component: SelectCategoryDialogComponent, componentProps: { items, clearButton } }).then((m) => {
      m.present();

      m.onDidDismiss<InstructionCategory>().then((data) => {
        if (data.data) {
          if (data.data.clear) {
            this.formGroup.get('parent').setValue(null);
          } else {
            const selected = { name: data.data.name, guid: data.data.guid };
            this.formGroup.get('parent').setValue(selected);
          }
        }
      });
    });
  }

  onSave() {
    const value = this.formGroup.value;
    if (value.guid) {
      this.instructions.updateCategory(value).then(() => this.dismiss());
    } else {
      this.instructions.saveCategory(value).then(() => this.dismiss());
    }
  }

  dismiss() {
    this._modal.dismiss();
  }
}
